import { useEffect, useState } from 'react'; 
import PageInputObj from './PageInputObjCopy'; 
import Grid from '@mui/material/Grid';
import applyFormat from '../functions/applyFormat';
import EntitledButton from './EntitledButton';
import ButtonComponent from './ButtonComponent';
import { Typography } from '@mui/material';
import { isNull } from 'lodash';

const RebateComponentDisplayCopy = ({ tag, values, setValues, config, portfolioId, showOverride=true, entitledBool=false, onClick=()=>{} }) => {
    // initialize state
    const [show, setShow] = useState(true); 

    // useEffect to clear values on config change
    useEffect(() => {
        let temp = values; 
        temp = applyFormat(temp, config, {}, 0); 
        setValues(values => values = temp); 
    }, [config, values]); 

    // useEffect to run on portfolioId change 
    useEffect(() => {
        if (showOverride && portfolioId && portfolioId['additionaldetails'] == '1') {
            setShow(show => show = true); 
        }
        else {
            setShow(show => show = false); 
        }
    }, [portfolioId, showOverride]);

    const boxColors = ["#FDE5E5","#E5F3E5","#F2F2FC"];

    const boxBorderColors = ["#FBCCCC","#CCE8CC","#E5E4F8"];

    // Box colors
    const getBoxColors = (index)  => {
        if(index < boxColors.length){
            return [boxColors[index],boxBorderColors[index]]; 
        }
        else{
            return  [boxColors[index%boxColors.length],boxBorderColors[index%boxColors.length]];
        }
    }
    
    // render all inputs 
    return ( 
        show ? 
            <div className="d-flex align-items-center gap-3" style={{flexWrap:'wrap'}}>
                <div className="d-flex align-items-center justify-content-center gap-3 flex-grow-1">
                    { config.map((el,index) => 
                        <div className = 'd-flex align-items-center justify-content-center p-5 pt-2 pb-2 w-100' style={{background:getBoxColors(index)[0],border:"1px solid"+getBoxColors(index)[1]}}>
                            <Typography 
                            sx={{
                                fontFamily: "Roboto regular, Helvetica, Arial, sans-serif",
                                fontSize:"16px",
                                fontWeight: "400",
                                marginRight:"8px",
                            }}
                                title={el['description']}
                            >
                                {el['description']+" :"}
                            </Typography>
                            <Typography
                            sx={{
                                fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
                                fontSize:"16px",
                                fontWeight: "700",
                            }}
                                title={(isNull(values[el['rebatecomponentid']]) || typeof(values[el['rebatecomponentid']]) == "undefined") ? "None" : values[el['rebatecomponentid']]}
                            >
                            {(isNull(values[el['rebatecomponentid']]) || typeof(values[el['rebatecomponentid']])=="undefined") ? "None" : values[el['rebatecomponentid']]}
                            </Typography>
                        </div>
                    )}
                </div>
                {entitledBool && <ButtonComponent tag='Edit' onButtonClick={onClick} border={'#3D3D3D 1px solid'} background={'#fff'} color={'#001317'}/>}
                {/* <EntitledButton entitledBool={entitledBool} tag='Edit' cssClass='summary-page-button'  onClick={onClick}/> */}
            </div>
        :<></>
    ); 
}

export default RebateComponentDisplayCopy; 